import React, { useEffect, useState } from "react";
import { NavLink, useParams, useSearchParams } from "react-router-dom";
import { InformacionFuncionario } from "../../components/EtapasDeCalificacion/InformacionFuncionario";
import { ListarPrecalificaciones } from "../../components/EtapasDeCalificacion/ListarPrecalificaciones";
import { Toolbar } from "../../layout/Toolbar/Toolbar";
import { cargarParticipante } from "../../utils/Datos";

export const VerProcesoFuncionario = () => {
  let [searchParams, setSearchParams] = useSearchParams();

  const { idProcess,id_participant }=useParams(); 
  /*const idProcess = searchParams.get("idProcess");
  const id_participant = searchParams.get("id_participant");*/
  console.log(idProcess,id_participant);

  const [idOfficer, setIdOfficer] = useState();

  useEffect(() => {
    cargarParticipante(id_participant).then((participante) => {
      if (participante != null) {
        setIdOfficer(participante.id_officer);
      }
    });
  }, []);

  let toolbarEnlaces = [
    {
      muted: "true",
      to: "/home",
      title: "Home",
      bullet: "false",
    },
    {
      muted: "true",
      to: "",
      title: "",
      bullet: "true",
    },
    {
      muted: "true",
      to: "/buscarProceso",
      title: "Buscar Proceso de Calificación",
      bullet: "false",
    },
    {
      muted: "true",
      to: "",
      title: "",
      bullet: "true",
    },
    {
      muted: "true",
      to: `/participacionProceso?idProcess=${idProcess}`,
      title: "Participación en proceso",
      bullet: "false",
    },
    {
      muted: "true",
      to: "",
      title: "",
      bullet: "true",
    },
    {
      muted: "false",
      to: null,
      title: " INFORMACION DEL FUNCIONARIO",
      bullet: "false",
    },
  ];

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Toolbar
        title="VER PROCESO DE CALIFICACIÓN"
        enlaces={toolbarEnlaces}
      />
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
          <div className="row gy-5 g-xl-8">
            <InformacionFuncionario
              id_participant={id_participant}
              idOfficer={idOfficer}
              idProcess={idProcess}
            ></InformacionFuncionario>

            <ListarPrecalificaciones
              id_participant={id_participant}
            ></ListarPrecalificaciones>
          </div>
        </div>
      </div>
    </div>
  );
};
